import { Component, OnInit } from '@angular/core';
import { DiscussionsService } from '../../../services/discussions.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";



@Component({
  selector: 'app-discussions-submit',
  templateUrl: './discussions-submit.component.html',
  styleUrls: ['./discussions-submit.component.scss']
})
export class DiscussionsSubmitComponent implements OnInit {
    pagecode: string = "disc-submit";
    module: string = "discussion";
    accessdenied: boolean = false;
    constructor(private route: ActivatedRoute, private _router: Router, private discussionService: DiscussionsService, private authentication: AuthenticationService, private common: CommonService) { }

    selectedTags: any[] = [];

    filteredTags: any[] = [];

    ngOnInit(): void {

        this.route.params.subscribe(val => {
            this.authentication.checkUserPageAccess(this.authentication._authentication.id, this.pagecode).subscribe(
                (res: any) => {
                    if (res.success && res.data) {
                        this.accessdenied = false;

                        var pageURL = this._router.routerState.snapshot.url;
                        this.authentication.addUserPageView(pageURL, this.pagecode, this.module);

                        // load page data
                        this.getALLTagslist();
                        this.getDiscussionCategory();
                        //

                    }
                    else
                        this.accessdenied = true;
                },
                (err: any) => {
                    console.error("checkUserPageAccess", err);
                    this.accessdenied = true;
                }
            );
        });



    }
    tags: any[] = [];

    getALLTagslist() {
        this.discussionService.getAllTags().subscribe(
            (res: any) => {
                this.tags = [];
                for (var i = 0; i < res.data.length; i++) {
                    this.tags.push(res.data[i]);
                }
                console.log("alltag", res)
            },
            (err: any) => {
                console.error("getAllTags err", err);
            }
        );
    }

    discussionCategories: any[] = [];
    getDiscussionCategory() {
        this.discussionService.getDiscussionCategory().subscribe(
            (res: any) => {
                for (var i = 0; i < res.data.length; i++) {
                    this.discussionCategories.push(res.data[i]);
                }
                if (this.discussionCategories.length > 0)
                    this.SelectedCategory = this.discussionCategories[0];
                //console.log("getDiscussionCategory", res)
            },
            (err: any) => {
                console.error("getDiscussionCategory err", err);
            }
        );
    }

    SelectedCategory: any = '';
    categoryDescriptionLabel: string = "";

    selectCategoryOption(evt: any) {

        var optionValue = evt.target.value;
        var item = this.discussionCategories.find(s => s.code == optionValue);
        this.SelectedCategory = item;
        this.categoryDescriptionLabel = item.descriptionLabel;
    }

    filterTag(event: any) {
        //in a real application, make a request to a remote url with the query and return filtered results, for demo we filter at client side
        let filtered: any[] = [];
        let query = event.query;
        for (let i = 0; i < this.tags.length; i++) {
            let tag = this.tags[i];
            if (tag.tagName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
                filtered.push(tag);
            }
        }

        this.filteredTags = filtered;
    }


    onSubmitDiscussionBoard() {
        // this.ShowMessage('hide', '', '');
        //if (this.toastr.index != 1) {
        //  this.toastr.dismissAllToastr();
        //}
        if (this.formValidation()) {

            this.btnSubmitDisabled = true;
            this.btnSubmitText = "Submiting";
            let _selectedTags = [];
            for (var i = 0; i < this.selectedTags.length; i++) {
                _selectedTags.push(this.selectedTags[i].tagId);
            }

            var _myDiscussionBoard = {
                PostTo: this.SelectedCategory.code,
                Title: this.discussion,
                Description: this.details,
                OwnerId: this.authentication._authentication.id,
                Tags: _selectedTags
                //,
                //Attachments: this.attachmentsObj
            };

            this.submitDiscussionService(_myDiscussionBoard);
        }
    }

    submitDiscussionService(_myDiscussionBoard: any) {

        this.discussionService.submitDiscussionBoard(_myDiscussionBoard).subscribe(
            (res: any) => {
                this.btnSubmitDisabled = false;
                this.btnSubmitText = "Submit";
                if (res.success) {
                    //console.log("setSelectedDiscussion", res)
                    var id = res.data['discussionId']
                    this._router.navigate(['/discussion/detail/' + id]);
                }
                else {
                    console.error("submitDiscussionService", res.error_message);
                    this.common.ShowMessage("error", res.error_message, "");
                }

            },
            (err: any) => {
                console.error("submitDiscussionService", err)
                this.btnSubmitDisabled = false;
                this.btnSubmitText = "Submit";
                this.common.ShowMessage("error", "Unexpected error occured. please try again later", "");
            }
        );
    }
    btnSubmitDisabled: boolean = false;
    btnSubmitText: string = "Submit";
    discussion: string = "";
    details: string = "";

    formValidation() {
        debugger;
        if (this.discussion === '' || this.details === '' || this.selectedTags.length == 0 || this.SelectedCategory.name === '') {
            this.common.ShowMessage('error', 'Subject and discussion description are mandatory!', '')
            return false;
        }
        else {
            return true;
        }
    }

    
}
